import { UserOutlined } from '@ant-design/icons'
import { Button, Spin } from 'antd'
import { useNavigate } from 'react-router-dom'

import { APP_STATUS } from 'src/constants/common'
import * as ROUTES from 'src/constants/routes'
import { useAppSelector } from 'src/store/hooks'
import { UserProfile } from './userProfile'

interface LoginProps {
  buttonIconPosition?: 'start' | 'end'
  style?: React.CSSProperties
  onLoginClick?: () => void
}

export const Login = ({ buttonIconPosition = 'start', style = {}, onLoginClick }: LoginProps) => {
  const navigate = useNavigate()
  const account = useAppSelector((state) => state.account)

  const handleLoginClick = () => {
    void navigate(ROUTES.LOGIN)
    if (onLoginClick) {
      onLoginClick()
    }
  }

  // Show loading spinner while checking session status
  if (
    account.getSessionStatus.status === APP_STATUS.LOADING ||
    account.getSessionStatus.status === APP_STATUS.INIT
  ) {
    return <Spin size="small" />
  }

  // If user is authenticated, show user profile dropdown
  if (account.isLogin && account.currentUser) {
    return <UserProfile />
  }

  // If user is not authenticated, show login button
  return (
    <Button
      type="primary"
      size="large"
      shape="round"
      icon={<UserOutlined />}
      iconPosition={buttonIconPosition}
      onClick={handleLoginClick}
      style={{ width: 120, height: 56, ...style }}
    >
      Login
    </Button>
  )
}
